import { render, staticRenderFns } from "./DynamicSummary.vue?vue&type=template&id=1c3c6c50&scoped=true&"
import script from "./DynamicSummary.vue?vue&type=script&lang=js&"
export * from "./DynamicSummary.vue?vue&type=script&lang=js&"
import style0 from "./DynamicSummary.vue?vue&type=style&index=0&id=1c3c6c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c6c50",
  null
  
)

export default component.exports